import { render, staticRenderFns } from "./PieVcDemo.vue?vue&type=template&id=7999d3c4&scoped=true&"
import script from "./PieVcDemo.vue?vue&type=script&lang=js&"
export * from "./PieVcDemo.vue?vue&type=script&lang=js&"
import style0 from "./PieVcDemo.vue?vue&type=style&index=0&id=7999d3c4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7999d3c4",
  null
  
)

export default component.exports